export const DONATE_URL = 'https://code4.ro/ro/doneaza';
export const COMMIT_GLOBAL_URL = 'https://www.commitglobal.org/en';